import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SearchService } from 'app/components/search/search.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { Subject, takeUntil } from 'rxjs';
import { AnalyticsService } from '../analytics/analytics.service';
import { FiltersService } from 'app/components/filters/filters.service';

@Component({
  selector: 'app-filters-selected',
  templateUrl: './filters-selected.component.html',
  styleUrls: ['./filters-selected.component.css']
})
export class FiltersSelectedComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  public orderFilters: Array<any> = [
    {
      id: 0,
      name: 'relevance',
      active: false,
      value_search: 'BY_RELEVANCE'
    },
    /**{
      name: 'newest',
      active: false,
      value_search: 'ONLY_NOVELTIES'
    },*/
    {
      id: 1,
      name: 'from_a_to_z',
      active: false,
      value_search: 'A_Z'
    },
    {
      id: 2,
      name: 'from_z_to_a',
      active: false,
      value_search: 'Z_A'
    }
  ];

  searchConfig: object = {};

  selectedHProps:any = [];
  selectedMProps:any = [];
  selectedCountries:any = [];
  selectedSectors:any = [];
  selectedHomeOds:any = [];
  selectedMultiEvents:any = [];



  @Input() hierarchicalProperties;
  @Input() countries;
  @Input() masterProperties;
  @Input() sectors;
  @Input() allOds;
  @Input() multiEvents;

  private readonly destroy$ = new Subject();

  selectedView: string;

  search:string = 'BY_RELEVANCE';

  selectedItems:any = {
    hierarchical:[],
    master:[],
    countries:[],
    sectors:[],
    ods:[],
    multiEvents:[]
  };

  constructor(private searchService: SearchService, public utilsService: UtilsService, public filtersService: FiltersService, private analyticsService: AnalyticsService) { }

  deleteAllFilters() {

    this.deleteSelectedItems(this.hierarchicalProperties, this.selectedHProps, 'hierarchical');
    this.deleteSelectedItems(this.masterProperties, this.selectedMProps, 'master');
    this.deleteSelectedItems(this.countries, this.selectedCountries, 'countries');
    this.deleteSelectedItems(this.allOds, this.selectedHomeOds, 'ods');
    this.deleteSelectedItems(this.sectors, this.selectedSectors, 'sectors');
    this.deleteSelectedItems(this.multiEvents, this.selectedMultiEvents, 'multiEvents');

    const orderFilter = this.orderFilters.find(item => item.value_search === this.searchConfig['searchOrder']);

    this.activeOrderFilter(this.orderFilters[0]);

  }

  activeOrderFilter(orderFilter: any) {

    this.disableOrderFilters();
    orderFilter.active = true;

    this.searchConfig = this.searchService.getSearchConfig();

    if (orderFilter.name !== 'newest') {
      this.searchConfig['searchOrder'] = orderFilter.value_search;
    } else {
      this.searchConfig['searchOrder'] = this.orderFilters[0].value_search;
      this.searchConfig['filter'] = orderFilter.value_search;
    }

    this.search = this.searchConfig['searchOrder'];

    let unifiedSearchIn = this.searchConfig;
    
    this.searchService.setSearchConfig(this.searchConfig);

    this.analyticsService.sendFilters('add', 'order', orderFilter.name, orderFilter.id);

    this.unifiedSearch(unifiedSearchIn);

  }

  disableOrderFilters() {
    for(let i = 0; i < this.orderFilters.length; i++) {
      this.orderFilters[i].active = false;
    }
  }

  initOrderFilters() {
    for(let i = 0; i < this.orderFilters.length; i++) {
      if (this.searchConfig['searchOrder'] === this.orderFilters[i].value_search && this.searchConfig['filter'] !== 'ONLY_NOVELTIES') {
        this.orderFilters[i].active = true;
      } else if (this.searchConfig['filter'] === this.orderFilters[i].value_search) {
        this.orderFilters[i].active = true;
      }
    }
  }

  unifiedSearch(unifiedSearchIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.searchService.unifiedSearch(unifiedSearchIn)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: object) => {
        this.unifiedSearchOk(data);
      },
        error => {
          this.unifiedSearchError(error);
        });

  }

  unifiedSearchOk(data) {
    this.loader.count--;
    this.searchService.setResetList(true);
    this.searchService.setItemsObs(data.list);
    this.searchService.setNumItemsObs(data.numElements);
    this.analyticsService.sendViewItemList(data.list, this.searchConfig['filter'] === 'ONLY_EXHIBITORS' ? 'exhibitor' : 'product', this.selectedView);
  }

  unifiedSearchError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getSelectedItems(items, selectedItems, type, firstIteration = true) {

    if (firstIteration) {
      this.selectedItems[type] = [];
    }

    let childsPropertyName = 'properties';

    if (type === 'hierarchical') {
      childsPropertyName = 'childHierarchicalProperties';
    }

    for (let i = 0; i < items.length; i++) {

      if (items[i].checked) {
        this.selectedItems[type].push(items[i]);
      }

      items[i][childsPropertyName] = items[i][childsPropertyName] || [];

      if (items[i][childsPropertyName].length > 0) {
        this.getSelectedItems(items[i][childsPropertyName], selectedItems, type, false);
      }

    }

    return this.selectedItems[type];

  }

  deleteSelectedItems(items, selectedItems, type, firstIteration = true) {

    if (firstIteration) {
      selectedItems = [];
    }

    let childsPropertyName = 'properties';

    if (type === 'hierarchical') {
      childsPropertyName = 'childHierarchicalProperties';
    }

    let valueKey = 'id';
    let propertyName = this.utilsService.setPropertyName(type);

    for (let i = 0; i < items.length; i++) {

      if (items[i].checked) {
        items[i].checked = false;
        this.searchService.removeItemFromProperty(propertyName, items[i][valueKey], items[i]);
      }

      items[i][childsPropertyName] = items[i][childsPropertyName] || [];

      if (items[i][childsPropertyName].length > 0) {
        this.deleteSelectedItems(items[i][childsPropertyName], selectedItems, type, false);
      }

    }

  }

  deleteSelectedItem(items, selectedItems, type, itemId, index) {

    let childsPropertyName = 'properties';
    let found = false;

    if (type === 'hierarchical') {
      childsPropertyName = 'childHierarchicalProperties';
    }

    let valueKey = 'id';
    let propertyName = this.utilsService.setPropertyName(type);

    for (let i = 0; i < items.length; i++) {

      if (items[i].id === itemId) {

        found = true;
        items[i].checked = false;
        selectedItems.splice(index, 1);
        this.searchService.removeItemFromProperty(propertyName, items[i][valueKey], items[i]);

        this.analyticsService.sendFilters('remove', propertyName, propertyName == 'selectedMultiEvents' ? items[i].label : items[i].translations, items[i][valueKey]);

        this.searchConfig = this.searchService.getSearchConfig();
        let unifiedSearchIn = this.searchConfig;

        this.unifiedSearch(unifiedSearchIn);

      }

      items[i][childsPropertyName] = items[i][childsPropertyName] || [];

      if (items[i][childsPropertyName].length > 0 && !found) {
        this.deleteSelectedItem(items[i][childsPropertyName], selectedItems, type, itemId, index);
      }

    }

  }


  ngOnInit() {
    this.searchConfig = this.searchService.getSearchConfig();
    this.initOrderFilters();

    this.search = this.searchConfig['searchOrder'];

    this.filtersService.getSelectedView().subscribe(data => {
      this.selectedView = data;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
